<section class="incidencia-comment-modal" [formGroup]="formRegistro">
  <header class="incidencia-comment-modal__header">
    <div class="incidencia-comment-modal__title-block">
      <span class="incidencia-comment-modal__eyebrow">Incidencias Desarrollo</span>
      <h2>{{ data.titulo }}</h2>
      <p>Registra el movimiento del defecto y adjunta evidencia relevante.</p>
    </div>

    <button
      type="button"
      mat-icon-button
      class="incidencia-comment-modal__close"
      (click)="onCloseClick()"
      aria-label="Cerrar modal"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="incidencia-comment-modal__body">
    <aside class="incidencia-comment-modal__summary">
      <article class="incidencia-comment-modal__summary-card">
        <span class="incidencia-comment-modal__summary-label">Estatus</span>
        <strong class="incidencia-comment-modal__status">
          {{ data.dataKey.estatus }}
        </strong>
      </article>

      <article class="incidencia-comment-modal__summary-card">
        <span class="incidencia-comment-modal__summary-label">Versión</span>
        <strong>{{ tituloVersion || "Sin versión" }}</strong>
      </article>

      <article class="incidencia-comment-modal__summary-card">
        <span class="incidencia-comment-modal__summary-label">Archivos</span>
        <strong>{{ evidencia.length }}</strong>
        <span class="incidencia-comment-modal__summary-text">
          Adjunta capturas, documentos o videos de soporte.
        </span>
      </article>
    </aside>

    <div class="incidencia-comment-modal__content">
      <!-- T3b: la incidencia es trazable; la resolución se entrega en la siguiente versión QA de la etapa. -->
      <section class="incidencia-comment-modal__version-pendiente" *ngIf="sinSelector as tarjeta"
        aria-labelledby="version-pendiente-titulo">
        <div class="incidencia-comment-modal__version-pendiente-cabeza">
          <h3 id="version-pendiente-titulo">Versión donde se resolvió</h3>
          <span class="incidencia-comment-modal__chip-pendiente">
            <span class="material-icons" aria-hidden="true">schedule</span>{{ nombrePendiente }}
          </span>
        </div>
        <p>Se entregará en: <strong>{{ tarjeta.seEntregaraEn }}</strong></p>
        <p>Versión vigente: <strong>{{ tarjeta.versionVigente }}</strong></p>
      </section>

      <mat-form-field appearance="outline" class="incidencia-comment-modal__field" *ngIf="conSelector">
        <mat-label>Versión</mat-label>
        <mat-select
          #versionSelect
          formControlName="version"
          [(ngModel)]="selectedVersion"
          panelClass="incidencia-desarrollo-version-select-panel"
        >
          <mat-option *ngFor="let version of listaversion" [value]="version.id">
            {{ version.nombre }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <ng-container *ngIf="esResolucionDesdeProceso; else descriptionField">
        <section class="incidencia-comment-modal__disclosure">
          <button
            type="button"
            class="incidencia-comment-modal__disclosure-toggle"
            [attr.aria-expanded]="resolucionExpandida"
            (click)="resolucionExpandida = !resolucionExpandida"
          >
            <span>
              <strong>Resolución</strong>
              <small>Describe la corrección aplicada.</small>
            </span>
            <mat-icon>{{ resolucionExpandida ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>

          <div class="incidencia-comment-modal__disclosure-body" *ngIf="resolucionExpandida">
            <mat-form-field appearance="outline" class="incidencia-comment-modal__field">
              <mat-label>Resolución</mat-label>
              <textarea
                matInput
                aria-label="Resolución"
                rows="10"
                maxlength="2000"
                formControlName="descripcion"
                placeholder="Describe la corrección aplicada"
              ></textarea>
            </mat-form-field>
            <p class="incidencia-comment-modal__field-error" role="alert"
              *ngIf="formRegistro.get('descripcion')?.touched && formRegistro.get('descripcion')?.invalid">
              La resolución es obligatoria.
            </p>
          </div>
        </section>

        <section class="incidencia-comment-modal__disclosure incidencia-comment-modal__disclosure--cause">
          <button
            type="button"
            class="incidencia-comment-modal__disclosure-toggle"
            [attr.aria-expanded]="causaOrigenExpandida"
            (click)="causaOrigenExpandida = !causaOrigenExpandida"
          >
            <span>
              <strong>Causa / Origen</strong>
              <small>Los primeros cinco porqués son obligatorios.</small>
            </span>
            <mat-icon>{{ causaOrigenExpandida ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>

          <div class="incidencia-comment-modal__disclosure-body" *ngIf="causaOrigenExpandida">
            <div class="incidencia-comment-modal__cause-header">
              <p>Capture la causa raíz en orden. Puede agregar más porqués si aplica.</p>
              <div class="incidencia-comment-modal__cause-actions">
                <button type="button" mat-icon-button aria-label="Más información sobre Causa u Origen"
                  (click)="abrirInformacionCausaOrigen()">
                  <mat-icon>info</mat-icon>
                </button>
                <button type="button" mat-button class="app-form-btn app-form-btn--secondary app-form-btn--compact"
                  (click)="agregarPorque()">
                  Agregar porqué
                </button>
              </div>
            </div>

            <p class="incidencia-comment-modal__field-error" role="alert" *ngIf="errorPorques">
              {{ errorPorques }}
            </p>

            <div class="incidencia-comment-modal__porques" formArrayName="porquesResolucion">
              <article class="incidencia-comment-modal__porque"
                *ngFor="let porque of porquesResolucion.controls; let i = index">
                <div class="incidencia-comment-modal__porque-question">
                  <span>{{ i + 1 }}</span>
                  <strong>{{ preguntaPorque(i) }}</strong>
                  <button type="button" mat-icon-button aria-label="Eliminar porqué" *ngIf="i >= 5"
                    (click)="eliminarPorque(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
                <!-- Sin maxlength en el input: el navegador cortaba en silencio lo pegado de más. -->
                <mat-form-field appearance="outline"
                  class="incidencia-comment-modal__field incidencia-comment-modal__field--porque">
                  <!-- El asterisco de las obligatorias lo pone Material (Validators.required). -->
                  <mat-label>Respuesta {{ i + 1 }}</mat-label>
                  <input matInput [formControlName]="i" [attr.aria-label]="'Respuesta ' + (i + 1)"
                    [errorStateMatcher]="errorAlEscribir" />
                  <mat-hint align="end">{{ largoPorque(i) }}/{{ limitePorque }}</mat-hint>
                  <mat-error *ngIf="porque.hasError('maxlength')">
                    Máximo {{ limitePorque }} caracteres: lleva {{ largoPorque(i) }}.
                  </mat-error>
                  <mat-error *ngIf="porque.hasError('required')">
                    La respuesta es obligatoria.
                  </mat-error>
                </mat-form-field>
              </article>
            </div>
          </div>
        </section>
      </ng-container>

      <ng-template #descriptionField>
        <mat-form-field appearance="outline" class="incidencia-comment-modal__field">
          <mat-label>Descripción</mat-label>
          <textarea
            matInput
            aria-label="Descripción"
            rows="10"
            maxlength="2000"
            formControlName="descripcion"
            placeholder="Describe el comentario o la acción realizada"
          ></textarea>
        </mat-form-field>
      </ng-template>

      <section class="incidencia-comment-modal__evidence-panel">
        <div class="incidencia-comment-modal__panel-header">
          <div>
            <h3>Evidencias</h3>
            <p>Selecciona archivos para adjuntar al comentario.</p>
          </div>

          <div class="incidencia-comment-modal__panel-actions">
            <label class="app-form-btn app-form-btn--secondary app-form-btn--compact incidencia-comment-modal__action-trigger">
              Agregar
              <input
                type="file"
                id="nameFile"
                hidden
                multiple
                accept="image/*,application/*,audio/*,video/*"
                (change)="subirEv()"
              />
            </label>

            <button
              type="button"
              class="app-form-btn app-form-btn--secondary app-form-btn--compact"
              [disabled]="btnElimina"
              (click)="elimina()"
            >
              Remover
            </button>
          </div>
        </div>

        <mat-selection-list
          class="incidencia-comment-modal__file-list"
          formControlName="evidenciasSeleccionadas"
          (selectionChange)="onNgModelChange()"
        >
          <mat-list-option
            *ngFor="let item of evidencia"
            [value]="item"
            class="incidencia-comment-modal__file-item"
          >
            <div class="incidencia-comment-modal__file-copy">
              <strong>{{ item.name }}</strong>
              <span>Archivo listo para adjuntar</span>
            </div>
          </mat-list-option>
        </mat-selection-list>

        <p class="incidencia-comment-modal__empty" *ngIf="!evidencia.length">
          No hay archivos seleccionados.
        </p>
      </section>
    </div>
  </div>

  <footer class="incidencia-comment-modal__footer">
    <button
      type="button"
      mat-raised-button
      class="btn app-form-btn app-form-btn--secondary"
      (click)="onNoClick()"
    >
      Cancelar
    </button>

    <button
      type="button"
      mat-raised-button
      class="btn app-form-btn app-form-btn--primary"
      (click)="onSave()"
    >
      Guardar
    </button>
  </footer>
</section>
